module.exports = __webpack_public_path__ + "img/img_C3.12.14.5fa072a3.png";